<template>
    <div>
        <mini-button variant="light"
                     @btnClick="openI18nModal">
            I18n
        </mini-button>

        <re-b-modal ref="i18nModal" header="I18n"
                    fit-content>
            <mini-table read-only
                        effect-origin-row
                        :items="localItems"
                        :fields="i18nFields"></mini-table>
        </re-b-modal>
    </div>
</template>

<script>
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "ViewI18n",
    mixins: [emCommonUtilMixin],
    components: {MiniTable, ReBModal, MiniButton},
    props: {
        items: Array,
    },
    data() {
        return {
            localItemMap: {},
            i18nFields: [
                {key: 'key', label: 'Key'},
                {key: 'ch', label: '中文', isInput: true},
                {key: 'en', label: 'English', isInput: true},
            ],
            i18nConfig: {},

        }
    },
    computed: {
        localItems() {
            return Object.values(this.localItemMap);
        },
    },
    watch: {
        items: {
            handler() {
                this.$nextTick(() => this.handleItems());
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        openI18nModal() {
            this.$refs.i18nModal.showModal();
        },
        handleItems() {
            let tempMap = {};
            for (let item of this.items) {
                let key = item.alias || item.key;
                if (key in this.localItemMap) {
                    tempMap[key] = this.localItemMap[key];
                } else {
                    tempMap[key] = {
                        key: key,
                        ch: this.i18nConfig[key + '__ch'] || item.label,
                        en: this.i18nConfig[key + '__en'] || this._camelToTitleCase(key)
                    };
                }
            }
            this.localItemMap = tempMap;
        },
        unpackConfig(config) {
            if (config) {
                let temp = {};
                let i18n = config.i18n;
                if (i18n) {
                    for (let i in i18n) {
                        let o = i18n[i];
                        for (let k in o) {
                            temp[k + '__' + i] = o[k];
                        }
                    }
                }
                this.i18nConfig = temp;
            } else {
                this.i18nConfig = {};
            }
            this.localItemMap = {};
        },
        gatherConfig() {
            let result = {};
            for (let iF of this.i18nFields) {
                if (iF.key !== 'key') {
                    let temp = {};
                    for (let item of this.localItems) {
                        let v = item[iF.key];
                        v !== undefined && (temp[item.key] = v);
                    }
                    result[iF.key] = temp;
                }
            }
            return {
                i18n: result
            }
        }
    }
}
</script>

<style scoped>

</style>
